import { render, staticRenderFns } from "./TlmContentCard.vue?vue&type=template&id=49fccf85"
import script from "./TlmContentCard.vue?vue&type=script&lang=js"
export * from "./TlmContentCard.vue?vue&type=script&lang=js"
import style0 from "./TlmContentCard.vue?vue&type=style&index=0&id=49fccf85&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default})
